<template>
   <div class="content-wrapper contact-sales">
      <div class="row justify-content-center">
         <div class="col-md-8">
            <ContactSalesForm class="mt-10 mb-10" />
         </div>
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex';
import ContactSalesForm from '../components/elforms/Sales';
import metaGenerator from '../util/meta.js';

export default {
   name: 'ContactSales',

   components: {
      ContactSalesForm,
   },

   computed: {
      ...mapState(['contactSalesPage']),
   },

   asyncData({ store }) {
      return Promise.all([store.dispatch('CONTACT_SALES_PAGE_DATA_FETCH')]);
   },

   metaInfo() {
      return metaGenerator(this.contactSalesPage);
   },
};
</script>

<style></style>
